import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { CopyButton, Truncate } from '@root/shared/ui-kit'

import type { PremiumPurchase } from '@root/entities/premium/model'

type Props = {
  purchase: PremiumPurchase.Purchase
}

export const PremiumPurchaseTableCurrencyCell: React.FC<Props> = ({
  purchase,
}) => {
  const { currency } = purchase
  if (!currency) {
    return (
      <Root>
        <Address>
          <Truncate start={5} end={4}>
            {purchase.currencyAddress}
          </Truncate>
        </Address>
        <CopyButton value={purchase.currencyAddress} size={12} />
      </Root>
    )
  }

  return (
    <Root>
      <CurrencyIcon currency={currency} size={22} withNetwork withPreview />
      <Ticker ellipsis>{currency.ticker}</Ticker>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 6px;
  min-width: 0;
`

const Ticker = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--text-12);
`

const Address = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--text-11);
`
